import { useAmplitude, EventNamesMap } from 'src/context/AmplitudeProvider';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import useStoreSlug from 'src/common/hooks/useStoreSlug';
import { CartCoupon, CouponDetails, Product } from 'src/types/common';
import { useCartContext } from 'src/context/CartProvider/useCartContext';
import { useCheckoutContext } from 'src/context/CheckoutProvider/useCheckoutContext';

const cartProductsToEventDataProducts = (products: Product[]) =>
  products.map((item) => {
    return {
      product_id: item.product.pk,
      product_name: item.product.name,
    };
  });

const useTrackCouponEvents = () => {
  const { user, isB2b } = useAuthContext();
  const { storeSlug } = useStoreSlug();
  const { logEvent } = useAmplitude();
  const { cartproducts } = useCartContext();
  const { couponDetails: activeCartCoupon } = useCheckoutContext();

  const trackAddCoupon = (cartCoupon: CartCoupon) => {
    if (user && storeSlug && user.active_cart) {
      const products = cartProductsToEventDataProducts(cartproducts);
      const isCouponApplied = typeof cartCoupon.total_with_coupon === 'number';

      logEvent(EventNamesMap.AddCoupon, {
        email: user.email,
        store_slug: storeSlug,
        cart_id: user.active_cart,
        coupon_code: cartCoupon.code,
        is_coupon_applied: isCouponApplied,
        is_b2b: !!isB2b,
        products,
      });
    }
  };

  const trackRemoveCoupon = ({
    couponCode,
    removed,
  }: {
    couponCode: string;
    removed: boolean;
  }) => {
    if (user && storeSlug && user.active_cart) {
      const products = cartProductsToEventDataProducts(cartproducts);
      const isCouponApplied = !removed;

      logEvent(EventNamesMap.RemoveCoupon, {
        email: user.email,
        store_slug: storeSlug,
        cart_id: user.active_cart,
        coupon_code: couponCode,
        is_coupon_applied: isCouponApplied,
        products,
        is_b2b: !!isB2b,
      });
    }
  };

  const trackOpenCouponDetails = (coupon: CouponDetails) => {
    if (user) {
      const isCouponApplied =
        activeCartCoupon?.code === coupon.code &&
        typeof activeCartCoupon.total_with_coupon === 'number';

      logEvent(EventNamesMap.OpenCouponDetails, {
        email: user.email,
        coupon_code: coupon.code,
        is_coupon_applied: isCouponApplied,
        is_b2b: !!isB2b,
      });
    }
  };

  return {
    trackAddCoupon,
    trackRemoveCoupon,
    trackOpenCouponDetails,
  };
};

export default useTrackCouponEvents;
